import { render, staticRenderFns } from "./courseFeeModal.vue?vue&type=template&id=4b95daa0&"
import script from "./courseFeeModal.vue?vue&type=script&lang=js&"
export * from "./courseFeeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports